export enum Feature {
  Move = 'move',
  Notification = 'notification',
  AskNewCaution = 'ask_new_caution',
  Refund = 'refund',
  MaintenanceMode = 'maintenance_mode',
}
